import React from 'react'
import { TableHeadersType } from '../../../../constant/tableHeadersConstants/tableHeadersType';
import { LoginResponseType } from '../../../../redux/auth/authTypes';
import { IdPasswordManagerListType } from '../../../../redux/stcoTools/stcoToolsType';
import { SearchBar, TableHeader, TableLoader } from '../../../commons'
import IdPasswordTableData from './IdPasswordTableData';
import ScrollToTop from '../../../commons/ScrollToTop';
import InfiniteLoader from '../../../commons/InfiniteLoader/InfiniteLoader';

type AppProps = {
  offset: number;
  fetching: boolean;
  loginData: LoginResponseType;
  idPasswordManagerList: [] | IdPasswordManagerListType[];
  tableHeaders: [] | TableHeadersType[];
  handleShowConfirmationModal: (data: number) => void;
  deleteIdPasswordRecord?: (data: number) => void;
  handleEditIdPasswordData: (data: any) => void;
  isEditIdPasswordManagerPresent?:boolean;
  isEditClientIdPasswordManagerPresent?:boolean;
}
const IdPasswordManagerTable = ({
  offset,
  fetching,
  tableHeaders,
  loginData,
  idPasswordManagerList,
  handleEditIdPasswordData,
  deleteIdPasswordRecord,
  handleShowConfirmationModal,
  isEditIdPasswordManagerPresent,
  isEditClientIdPasswordManagerPresent
}: AppProps) => {
  return (
    <>
      {
        fetching && offset === 0 ?
          <TableLoader
            Rows={10}
            ColumnPerRow={8}
          /> :
          <div className="jobsType" style={{ overflowX: "scroll" }}>
            <table className="table thead-light table-bordered">
              <thead className='text-start sticky-table-header'>
                <TableHeader
                  tableHeader={tableHeaders}
                />
              </thead>
              <tbody>
                <IdPasswordTableData
                  deleteIdPasswordRecord={deleteIdPasswordRecord}
                  handleShowConfirmationModal={handleShowConfirmationModal}
                  idPasswordManagerList={idPasswordManagerList}
                  tableHeaders={tableHeaders}
                  loginData={loginData}
                  handleEditIdPasswordData={handleEditIdPasswordData}
                  isEditIdPasswordManagerPresent={isEditIdPasswordManagerPresent}
                  isEditClientIdPasswordManagerPresent={isEditClientIdPasswordManagerPresent}
                />
                <div style={{ display: fetching ? "none" : "inline" }}><ScrollToTop /></div>
              </tbody>
            </table>
          </div>
      }
    </>
  )
}

export default IdPasswordManagerTable